export const filterTransactionsSearchInData = (
	transactions,
	searchBy,
	data,
) => {
	const normalizedSearch = data.toUpperCase();
	const includesSearch = value =>
		value.toUpperCase().includes(normalizedSearch);

	switch (searchBy) {
		case 'doc_number':
			return transactions.filter(transaction =>
				includesSearch(transaction.doc_number),
			);
		case 'transaction_type':
			return transactions.filter(transaction =>
				includesSearch(transaction.transaction_type_name),
			);
		case 'method':
			return transactions.filter(transaction =>
				includesSearch(transaction.method_name),
			);
		case 'owarehouse':
			return transactions.filter(transaction =>
				includesSearch(transaction.owarehouse_name),
			);
		case 'dwarehouse':
			return transactions.filter(transaction =>
				includesSearch(transaction.dwarehouse_name),
			);
		case 'creator':
			return transactions.filter(transaction =>
				includesSearch(transaction.creator_name),
			);
		case 'entity':
			return transactions.filter(transaction =>
				includesSearch(transaction.entity_name),
			);
		case 'completed':
			return transactions.filter(transaction =>
				includesSearch(transaction.completed_label),
			);
		case 'all':
			return transactions.filter(transaction =>
				[
					transaction.doc_number,
					transaction.transaction_type_name,
					transaction.method_name,
					transaction.owarehouse_name,
					transaction.dwarehouse_name,
					transaction.creator_name,
					transaction.entity_name,
					transaction.completed_label,
				].some(includesSearch),
			);
		default:
			return transactions;
	}
};
